import { Outlet, Navigate } from 'react-router-dom';

import FirstLogin from '../pages/firstLogin/FirstLogin';

// layouts

import LoginPage from '../pages/Login/loginPage';
// ----------------------------------------------------------------------

const AuthRoutes = {
  path: '*',
  element: <Outlet />,
  children: [
    {
      path: 'login',
      element: <LoginPage />,
    },
    { path: 'resetPassword', element: <FirstLogin /> },
    {
      path: '*',
      element: <Navigate to="/login" replace />,
    },
  ],
};

export default AuthRoutes;
